<template>
  <div
    class="ssu-info"
    :class="{
      single: isSingle
    }"
    @click.stop="goDetail"
  >
    <div class="good-price">
      <div v-if="!!ssu.ssuPrice.priceShield" class="no-login">
        {{ ssu.ssuPrice.priceShieldText }}
      </div>
      <template v-else>
        <div class="price-wrapper">
          <span class="prefix">{{ unitPrice.prefix }}</span>
          <span class="value">{{ unitPrice.price }}</span>
          <span v-if="ssu.ssuPrice.unitPrice" class="unit"
            >/{{ unitPrice.unit }}</span
          >
        </div>
        <div v-if="ssu.ssuPrice.totalPriceWithFp" class="ssu-fpm-text">
          {{ ssu.ssuPrice.totalPriceWithFp }}
        </div>
      </template>

      <NewOperator
        :computed-s-su="ssu"
        :is-hint="sku.promise.isHintNoArriveAm"
        class="operator"
        @add="addGoods"
        @subtract="subtractGoods"
        @goDetail="goDetail"
      />
    </div>

    <GoodTag v-if="tagList.length > 0" :good-tags="tagList" class="tags" />
    <div v-if="depositInfo" class="ssu-deposit">{{ depositInfo }}</div>
  </div>
</template>

<script>
import NewOperator from '@/common/widgets/newOperator/newIndex.vue'
import GoodTag from '@/common/cms/modules/goods/template/widgets/new-good-tag.vue'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import { mapState } from 'vuex'
export default {
  components: {
    NewOperator,
    GoodTag
  },
  props: {
    ssu: {
      type: Object,
      default: () => {}
    },
    sku: {
      type: Object,
      default: () => {}
    },
    isSingle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customOperator: {
        simple: false,
        showPromoteTip: true,
        type: 'normal'
      }
    }
  },
  computed: {
    ...mapState('pop', ['shop']),

    // 单价展示处理
    unitPrice() {
      const approximateShow = this.ssu.ssuPrice.isShowWeightUnitPrice === 1
      return {
        prefix: approximateShow ? '约￥' : '￥',
        price: this.ssu.ssuPrice[
          approximateShow ? 'weightUnitPrice' : 'unitPrice'
        ],
        unit: this.ssu.ssuPrice[
          approximateShow ? 'weightPriceUnit' : 'priceUnit'
        ]
      }
    },
    tagList() {
      return this.ssu?.ssuTags || []
    },
    depositInfo() {
      const depositInfo =
        this.ssu.ssuPrice.depositInfo ||
        this.ssu.ssuPrice.packagePriceMsg ||
        null
      return depositInfo
    }
  },
  methods: {
    // 统一商品模块埋点上报方法
    tracerReport(type) {
      const ssu = this.ssu
      this.$track(this.$trackMap.pop[type], {
        ssu_id: ssu.ssuId,
        sku_id: ssu.sku_id,
        pop_id: Number(this.shop.id),
        price: ssu?.priceSpm || ''
      })
    },
    // 商品加购处理
    addGoods() {
      // 加购埋点
      this.tracerReport('plusShoppingCart')
    },
    // 商品减购处理
    subtractGoods() {
      // 减购埋点
      this.tracerReport('minusShoppingCart')
    },
    goDetail() {
      this.tracerReport('goShopDetail')
      const ssu = this.ssu
      const spm = 'n.314.1223.0'
      const tickReferId = `${spm}.${this.skuIndex}`
      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: ssu.ssuId,
        tickReferId
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.ssu-info {
  margin-top: 0.16rem;
  &.single {
    margin-top: 0.08rem;
  }
  .good-price {
    display: flex;

    position: relative;

    align-items: baseline;
    .no-login {
      margin-top: 0.1rem;

      font-size: 0.32rem;
      font-weight: 500;
      color: #f03100;
    }

    .price-wrapper {
      display: inline-block;

      margin-top: 0.08rem;

      font-weight: bold;
      white-space: nowrap;
      color: #f03100;

      .prefix {
        font-size: 0.2rem;
      }
      .value {
        font-size: 0.44rem;
      }
      .unit {
        font-size: 13px;
      }
    }

    .ssu-fpm-text {
      display: inline-block;

      margin-left: 0.08rem;

      font-size: 0.26rem;
      font-weight: normal;
      white-space: nowrap;
      color: #262626;
    }
  }
  .tags {
    display: flex;

    position: relative;

    margin-top: 0.12rem;
    overflow: hidden;

    flex-wrap: nowrap;
    align-items: center;

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;

      width: 0.4rem;

      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        #fff 100%
      );

      content: '';
    }
  }
  .ssu-deposit {
    margin-top: 0.16rem;

    font-size: 0.26rem;
    letter-spacing: 0;
    color: #666666;
  }
  .operator {
    position: absolute;
    right: 0;
    bottom: -0.04rem;
  }
}
</style>
